import React from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';

import { Stack } from '../components';
import AppRouter from './Router';
import colors from '../common/colors';

const theme = createTheme({
  palette: {
    primary: { main: colors.grey_200 }, // #3b4960
    secondary: { main: colors.neutral_200, contrastText: colors.grey_200 }, // #f1f2f3
    error: { main: colors.red_200 }, // #b11b27
    warning: { main: colors.orange_200 }, // #e55e38
    success: { main: colors.green_200 }, // #0a875a
    info: { main: colors.grey_200 }, // #3b4960
    text: {
      primary: colors.grey_200,
      secondary: colors.grey_300,
      disabled: colors.grey_disabled,
    },
    background: {
      default: colors.white,
      paper: colors.white,
    },
  },
  typography: {
    fontFamily: '"Open Sans", sans-serif',
    h1: { fontSize: 96 },
    h2: { fontSize: 60 },
    h3: { fontSize: 48 },
    h4: { fontSize: 34 },
    h5: { fontSize: 24 },
    h6: { fontSize: 20 },
    subtitle1: { fontSize: 16 },
    subtitle2: { fontSize: 14 },
    body1: { fontSize: 16 },
    body2: { fontSize: 14 },
    caption: { fontSize: 12 },
    overline: { fontSize: 12 },
    button: {
      textTransform: 'none',
    },
  },
  components: {
    MuiButton: {
      defaultProps: {
        color: 'primary',
        size: 'medium',
        variant: 'contained',
        disableElevation: true,
      },
    },
    MuiCheckbox: {
      defaultProps: {
        color: 'primary',
        size: 'medium',
      },
    },
    MuiFormControl: {
      defaultProps: {
        fullWidth: true,
        size: 'medium',
        variant: 'filled',
      },
    },
    MuiSelect: {
      defaultProps: {
        size: 'small',
        variant: 'filled',
      },
    },
    MuiTextField: {
      defaultProps: {
        size: 'small',
        variant: 'filled',
      },
      styleOverrides: {
        root: {
          '& .Mui-disabled': {
            opacity: 0.5,
            color: colors.disabled_grey,
            WebkitTextFillColor: colors.grey_200,
          },
        },
      },
    },
    MuiChip: {
      defaultProps: {
        color: 'default',
        size: 'medium',
        variant: 'filled',
      },
    },
    MuiTooltip: {
      defaultProps: {
        enterDelay: 500,
      },
    },
  },
});

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <Stack className="App">
        <AppRouter />
      </Stack>
    </ThemeProvider>
  );
};

export default App;
